export function mergeProgramAndSchedule(sessions, meetings) {
    return [
        ...sessions,
        ...meetings.map((m) => ({
            ...m,
            _isMeeting: true,
        })),
    ];
}
